import { render } from "./daythree.vue?vue&type=template&id=8d36434c"
import script from "./daythree.vue?vue&type=script&lang=js"
export * from "./daythree.vue?vue&type=script&lang=js"

import "./daythree.vue?vue&type=style&index=0&id=8d36434c&lang=scss"
script.render = render

export default script